import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import {
  calculateCapacity,
  estimatePrice,
  getVenueStartingCost,
  NewInquiry,
  Venue,
  VenueSpace
} from "sweet-global";
import { Title } from "sweet-web/components/universal/Text";
import VenuePreview from "sweet-web/components/universal/VenuePreview";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import { Filters } from "sweet-web/redux/search/types";
import * as selectors from "sweet-web/redux/selectors";
import { GetVenues } from "sweet-web/redux/venue/actions";
import LoadingVenues from "./LoadingVenues";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 0px 0 40px 0;
  overflow: visible;
  z-index: 1;
  @media screen and (max-width: 600px) {
    /* mobile styling */
    padding: 40px 0;
  }
`;

const VenuesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: calc(100% + 20px);
  margin-left: -10px;
  margin-right: -10px;
  margin-top: 10px;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Venues: React.FC<Props> = props => {
  const [filtering, setFiltering] = useState(false);

  const createFilter = (filters: Filters) => (venue: Venue): boolean => {
    const capacity = calculateCapacity(venue);
    if (
      filters.guests &&
      (capacity.max < filters.guests || capacity.min > filters.guests)
    )
      return false;
    if (filters.eventType && !venue.eventTypes.includes(filters.eventType))
      return false;

    if (filters.guests && filters.budget) {
      let cheapestSpace: string;
      let lowestAmount: number;
      Object.keys(venue.spaces).forEach(venueSpaceId => {
        const space = venue.spaces[venueSpaceId];
        if (!lowestAmount || lowestAmount > space.startingCost.amount) {
          cheapestSpace = venueSpaceId;
          lowestAmount = space.startingCost.amount;
        }
      });

      const filterInquiry: NewInquiry = {
        length: 2,
        guests: filters.guests,
        spaces: {
          [cheapestSpace]: true
        }
      };
      const estimatedPrice = estimatePrice(venue, filterInquiry);
      if (estimatedPrice.total && estimatedPrice.total.amount > filters.budget)
        return true;
    } else if (filters.budget) {
      const startingCost = getVenueStartingCost(venue);
      if (startingCost.amount > filters.budget) return false;
    }

    return true;
  };

  let filter = createFilter(props.filters);

  const filterVenues = (filterFn: (venue: Venue) => boolean) =>
    Object.values(props.venues).map(venue => {
      if (filterFn(venue)) {
        return (
          <VenuePreview
            key={`discover-results-venue-${venue.id}`}
            venue={venue}
            onClick={() => props.history.push(`/v/${venue.id}`)}
          />
        );
      } else return null;
    });

  let FilteredVenues = filterVenues(filter);

  useEffect(() => {
    setFiltering(true);
    filter = createFilter(props.filters);
    FilteredVenues = filterVenues(filter);
    setTimeout(() => {
      setFiltering(false);
    }, 200);
  }, [props.filters]);

  return (
    <Wrapper>
      <Title style={{ marginBottom: 0 }}>Featured Venues</Title>
      {!filtering && <VenuesWrapper>{FilteredVenues}</VenuesWrapper>}
      {filtering && <LoadingVenues />}
    </Wrapper>
  );
};

const mapState = (state: RootState) => ({
  venues: selectors.venues(state),
  filters: selectors.searchFilters(state)
});
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      GetVenues
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(withRouter(Venues));
